<template>
    <section class="m-4">
        <div v-if="loaded" class="lg:w-1/2 mx-auto">
            <section class="mt-8 my-4">
                <p class="my-2 font-bold">Delivery Slots</p>
            
                <p class="my-2">By default, emails will land in the member's inbox only at these hours.</p>

                <p class="text-gray-darker text-sm">All times will be in the team member's local timezone.</p>

                <div class="mt-2">
                    <div class="rounded bg-gray-light">
                        <div class="flex items-start px-3 py-6">
                            <div class="mx-3 flex-1 -mt-1">
                                <div class="mt-2 flex flex-wrap items-center">
                                    <span v-for="(hour, index) in schedule.hours" :key="index">
                                        <vue-timepicker
                                            format="hh:mma"
                                            placeholder="hh:mm"
                                            :minute-interval="10"
                                            close-on-complete
                                            hour-label="hour"
                                            minute-label="minute"
                                            apm-label=" "
                                            auto-scroll
                                            v-model="hour.raw"
                                        />
                                    </span>
                                    <button class="bg-primary-lighter text-primary h-8 w-8 rounded-full focus:outline-none active:outline-none" @click="addNewHour">
                                        <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <span class="border-t border-gray-dark block"></span>

            <section class="mt-4">
                <p class="my-2 font-bold">VIPs</p>
            
                <p class="my-2">By default, emails matching any of the following VIPs will land immediately in the member's inbox.</p>

                <div class="mt-4">
                    <p class="text-gray-darker text-sm">Emails from any of these domains will be immediately delivered.</p>
                    <tag-input
                        class="bg-gray-light"
                        placeholder="Add domains..."
                        :current="vips.domains" 
                        @change="newDomains => vips.domains = newDomains"
                    />
                    <div class="w-full">
                        <p class="text-destructive" v-if="errors.domains">{{ errors.domains }}</p>
                    </div>
                </div>

                <div class="mt-4">
                    <p class="text-gray-darker text-sm">Emails from any of these email addresses will be immediately delivered.</p>
                    <tag-input
                        class="bg-gray-light"
                        placeholder="Add email address..."
                        :current="vips.addresses" 
                        @change="newAddresses => vips.addresses = newAddresses"
                    />
                    <div class="w-full">
                        <p class="text-destructive" v-if="errors.addresses">{{ errors.addresses }}</p>
                    </div>
                </div>
            </section>

            <div class="mt-12 pb-12">
                <progressable-button
                    type="submit"
                    class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                    :loading="loading"
                    state="Saving..."
                    @click.native="submit"
                >
                    Save changes
                </progressable-button>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>
    </section>
</template>

<script>

export default {
    props: {
        team: {
            type    : Object,
            required: true,
        }
    },
    data() {
        return {
            loaded  : true,
            loading : false,
            errors  : {
                domains  : null,
                addresses: null,
            },
            schedule: {
                hours: Schedule.makeRawHours([]),
            },
            vips: {
                domains  : [],
                addresses: [],
            },
        }
    },
    mounted() {
        this.loadTeam();
    },
    methods: {
        addNewHour() {
            this.schedule.hours.push(Schedule.emptyHour());
        },
        loadTeam() {
            axios.get(`/api/teams/${this.team.id}`)
                .then(response => {
                    this.schedule.hours = Schedule.makeRawHours(response.data.data.default_schedule.hours);
                    if (response.data.data.default_vips) {
                        this.vips = response.data.data.default_vips;
                    }
                })
                .catch(console.error);
        },
        submit() {
            this.loading = true;
            this.errors = {};
            
            axios.put(`/api/teams/${this.team.id}/defaults`, {
                schedule: {type: 'hours', hours: Schedule.makeHoursFromRaw(this.schedule.hours)},
                vips    : this.vips,
            })
            .catch(err => {
                if(err.response.status === 422) {
                    this.handleErrors(err.response.data);
                } else {
                    console.error(err);
                }
            })
            .then(() => {
                this.loading = false;
            });
        },
        handleErrors(response) {
            if(Object.keys(response.errors).some(function(k){ return ~k.indexOf("vips.domains.") })){
                // it has invalid domains
                this.errors.domains = 'One or more of these are not valid domains.'
            }

            if(Object.keys(response.errors).some(function(k){ return ~k.indexOf("vips.addresses.") })){
                // it has invalid addresses
                this.errors.addresses = 'One or more of these are not valid email addresses.'
            }
        },
    }

}
</script>